import { Box, Flex, Tag, Tooltip } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { FiltersPreviewProps } from './FiltersPreview.types';

export const FiltersPreview = memo<FiltersPreviewProps>((props) => {
    const { filters } = props;

    return (
        <Box color='silver80' radius='small' spacing='12' minHeight={28}>
            <Flex direction='row' spacing='8'>
                {filters.map((filter) => (
                    <Tooltip
                        key={filter}
                        size='small'
                        maxWidth={600}
                        activator={
                            <Tag
                                outline
                                size='small'
                                color='midnight80'
                                data-qa='report-filter'
                                backgroundColor='white100'
                                title={filter}
                            >
                                {filter}
                            </Tag>
                        }
                    >
                        {filter}
                    </Tooltip>
                ))}
            </Flex>
        </Box>
    );
});

FiltersPreview.displayName = 'FiltersPreview';
